import "./service-categories.css";
import { useState } from "react";
import { serviceCategoriesData } from "../../data/ServiceCategoriesData";
import ServiceCategoriesCard from "../service-categories-card/ServiceCategoriesCard";

function ServiceCategories({
  isNavModalOpen = null,
  setIsNavModalOpen = null,
}) {
  const [hoveredCardId, setHoveredCardId] = useState(null);

  return (
    <div className="service-categories">
      {serviceCategoriesData.map((service) => (
        <ServiceCategoriesCard
          key={service.id}
          data={service}
          isNavModalOpen={isNavModalOpen}
          setIsNavModalOpen={setIsNavModalOpen}
          hoveredCardId={hoveredCardId}
          setHoveredCardId={setHoveredCardId}
        />
      ))}
    </div>
  );
}

export default ServiceCategories;
